import { useRef } from 'react';
import { Carousel2 } from '@intigral/ui/components/Carousel2';
import { SectionHeaderWithPagination } from '@intigral/ui/components/SectionHeaderWithPagination';
import h from '../../../helpers/common';
import f from '../../../helpers/formatter';
import { __ } from '../../../translations';
import _ from 'lodash';
import { useConfigurationSections } from '../../../hooks/useConfiguration';
import CastCrewModal from '../../../components/ui/CastCrewModal';
import { CastAndCrewCard } from '@intigral/ui';
import { appConfig } from '../../../config/app.config';
import { useConfiguration } from '../../../hooks/useConfiguration';
import { iCastCrewProps } from '../types/iCastCrew';
import { usePersons } from '../hooks/usePersons';

export const CastCrew: React.FC<iCastCrewProps> = ({ meta, id, contentId, ...props }) => {
    const componentId = id ? id : '';
    const swiperElement = useRef(null);

    const { data: newConfig } = useConfiguration();
    const language = h.getLang();
    const { paidVsFree } = useConfigurationSections();
    const enableLockIcon = paidVsFree?.lockIconEnable || false;

    const { isLoading, data, modalSettings, isModalOpened, modalContent, openDetailOverlay } = usePersons(
        id,
        contentId
    );

    return (
        <>
            <section id={componentId} data-test-id="cast-crew" {...props}>
                {data?.castCrewList?.length ? (
                    <>
                        <SectionHeaderWithPagination
                            title={f.getComponentTitle(meta)}
                            className="paging-cast-and-crew"
                            isLoading={isLoading}
                        />
                        <Carousel2
                            isLoading={isLoading}
                            swiperSettings={{
                                autoplay: false,
                                loop: false,
                                dir: language == 'ar' ? 'rtl' : 'ltr',
                                slidesPerGroup: 1,
                                slidesPerView: 3,
                                breakpoints: {
                                    560: {
                                        slidesPerView: 3,
                                    },
                                    768: {
                                        slidesPerView: 4,
                                    },
                                    924: {
                                        slidesPerView: 6,
                                    },
                                    1212: {
                                        slidesPerView: 6,
                                    },
                                },
                                pagination: {
                                    el: '.paging-cast-and-crew',
                                    clickable: true,
                                },
                            }}
                            ref={swiperElement}
                        >
                            {data?.castCrewList?.map((item, index) => {
                                const position = item?.position
                                    ?.slice(0, 2)
                                    .map((pos) => {
                                        return __(`cast_crew_${(pos.trim() || '').toLowerCase()}`);
                                    })
                                    .join(', ');
                                return (
                                    <CastAndCrewCard
                                        DetailsButton={(children) => <span>{children}</span>}
                                        photoSrc={
                                            item?.image
                                                ? h.getImagizerUrl(
                                                      item?.image,
                                                      newConfig.imagizer?.components_images.VOD_LIST_ITEM
                                                  )
                                                : appConfig.defaultPortraitImage
                                        }
                                        title={h.isEnglishLang() ? item.title : item.titleAr}
                                        position={position?.trim() || null}
                                        key={`CastAndCrew_${index}`}
                                        isDetailsOverlay={true}
                                        onClick={() => modalSettings.openModal(item)}
                                        isLoading={isLoading}
                                    />
                                );
                            })}
                        </Carousel2>
                    </>
                ) : null}
            </section>
            <CastCrewModal
                isModalOpened={isModalOpened}
                modalContent={modalContent}
                closeModal={modalSettings.closeModal}
                openDetailOverlay={openDetailOverlay}
                enableLockIcon={enableLockIcon}
            />
        </>
    );
};
